export const API_BASE_URL =
	'https://internal.supremecomponents.com/zeeshanapi/api';

export const MPN_SUBSTITUTION_URL =
	'https://internal.supremecomponents.com/faizanapi/api';
// export const MPN_SUBSTITUTION_URL = 'http://localhost:8000/api';
